import {
    Box,
    createStyles,
    makeStyles,
    Theme,
    Container,
} from '@material-ui/core';
import { TitleBackBar } from '../header/TitleBar';

import { Document, Page, pdfjs } from 'react-pdf';
import {
    member as v_member,
    basic,
    product as v_product,
    Values,
} from '../../request/values';
import React, { useEffect, useRef, useState } from 'react';
import { COLORS } from '../Theme';
import { useHistory } from 'react-router-dom';
import { maxWidth } from '@material-ui/system';

const SERVER = basic.server;
//pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        pdfContainer: {
            // overflowX: 'auto',
            // overflowY: 'auto',
            overflow: 'auto',
            width: '100%',
            marginTop: '1.5vh',
            // marginLeft: '-8vw',
        },
        pdfPage: {
            // width: '200px',
        },
        titleFont: {
            fontSize: '3.6vw',
        },
    })
);

const ManaulView: React.FC<any> = (props) => {
    const classes = useStyles();
    const width = getWidth(window?.innerWidth);
    const [numPage, setNumPage] = useState<number | null>(null);
    const history = useHistory();

    const state: any = history.location.state;
    const productMenualFile = state.productMenualFile;

    // const stageCanvasRef = useRef(null);
    // useEffect( () => {
    //     if(stageCanvasRef.current){
    //         let height = stageCanvasRef.current!.offsetHeight;
    //         let width  = stageCanvasRef.current!.offsetWidth;
    //     }

    // }, [stageCanvasRef]);

    // const file = useMemo(() => ({props.product_menual_file}), [props.product_menual_file]);

    const onDocumentLoadSuccess = (document: any) => {
        console.log('load success', document);
        const parentDiv = document;
        setNumPage(document.numPages);
    };
    function getWidth(innerWidth: number) {
        if (innerWidth) {
            if (innerWidth < 748) {
                return innerWidth;
            } else if (innerWidth >= 748) {
                if (innerWidth - 290 > 1024) {
                    return 1024;
                } else return innerWidth - 290;
            }
        }
    }
    return (
        <Container maxWidth={false} disableGutters={true}>
            <TitleBackBar
                history={history}
                title="설명서보기"
                titleIcon="license"
            />
            <div className={classes.pdfContainer}>
                <Document
                    // file={'/dummy.pdf'}
                    file={{
                        url:
                            SERVER + v_product.display_file + productMenualFile,
                        // '/dummy.pdf'
                        // 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
                        // 'http://localhost:3001/v3/displayFile?fileName=' + props.product_menual_file,
                        //'/images/manual/2level_burgicar_manual.pdf', // + productMenualFile,
                        // SERVER + '/displayFile?fileName=' + props.product_menual_file,
                    }}
                    // options={{ workerSrc: "/pdf.worker.js" }}
                    onLoadSuccess={onDocumentLoadSuccess}
                    onLoadError={(error) =>
                        console.log(
                            'Error while loading document! ' + error.message
                        )
                    }
                    loading={''}
                >
                    {Array.from(new Array(numPage), (el, index) => (
                        <Page
                            width={width}
                            className={classes.pdfPage}
                            key={`page_${index + 1}`}
                            pageNumber={index + 1}
                            renderTextLayer={false}
                            renderAnnotationLayer={false}
                        />
                    ))}
                </Document>
            </div>
        </Container>
    );
};

export default ManaulView;
